export default __webpack_public_path__ + "static/media/icon-reverse.9aff3121.svg";